import { render, staticRenderFns } from "./CanopySidebar.vue?vue&type=template&id=fdf646e0&scoped=true&"
import script from "./CanopySidebar.vue?vue&type=script&lang=ts&"
export * from "./CanopySidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf646e0",
  null
  
)

export default component.exports